module.exports = __webpack_public_path__ + "img/投影@2x.1ba24c14.png";